module.exports = __webpack_public_path__ + "img/clube0.c484f44b.jpeg";